export default {
  getRowAvailable(row) {
    const max_width = row.sections.reduce((a, c) => Math.max(a, c.width), 0);
    return {
      rack_kit_hard: [1850, 2000, 2200, 2350, 2550, 3100].includes(row.height),
      tier_shelf_hard: ([300, 400, 500, 600].includes(row.depth) && row.sections.every(section => section.width === 1000)),
      tier_shelf_ribs: max_width < 1500,
      side_strips: row.depth < 700,
      side_wall: row.depth < 700,
      side_screen: row.depth == 500,
    };
  },

  getSectionAvailable(section) {
    return {
      back_strips: section.width < 1500,
      back_wall: section.width < 1500,
      back_screen: section.width == 1000,
    };
  },

  getWeight(separate, capacity, thrusters) {
    const rack_kit_weights = {
      separate: {
        standart: {
          g2: 500,
          g3: 550,
          gall: 600,
          t2: 575,
          t3: 600,
          tall: 750,
        },
        strong: {
          g2: 750,
          g3: 825,
          gall: 900,
          t2: 865,
          t3: 900,
          tall: 1100,
        },
        hard: {
          g2: 1000,
          g3: 1100,
          gall: 1200,
          t2: 1150,
          t3: 1200,
          tall: 1500,
        },
      },
      common: {
        standart: {
          g2: 400,
          g3: 440,
          gall: 480,
          t2: 0,
          t3: 0,
          tall: 0,
        },
        strong: {
          g2: 600,
          g3: 660,
          gall: 720,
          t2: 0,
          t3: 0,
          tall: 0,
        },
        hard: {
          g2: 800,
          g3: 880,
          gall: 960,
          t2: 0,
          t3: 0,
          tall: 0,
        },
      },
    };

    const tier_shelf_weights = {
      standart: {
        plain: 100,
        ribs: 110,
      },
      strong: {
        plain: 150,
        ribs: 165,
      },
      hard: {
        plain: 200,
        ribs: 220,
      },
    };

    const rack_kit_type = capacity.rack_kit_hard ? 'hard' : 'strong';
    const tier_shelf_type = capacity.tier_shelf_hard ? 'hard' : 'strong';

    return {
      rack_kit_weight: (thrusters === 'adjustable' ? 350 : rack_kit_weights[separate ? 'separate' : 'common'][rack_kit_type][capacity.fasteners]),
      tier_shelf_weight: tier_shelf_weights[tier_shelf_type][capacity.tier_shelf_ribs ? 'ribs' : 'plain'],
    };
  },

  getRowItems(data, row) {
    if (row.sections.length === 0)
      return {};

    const items = [];

    function addItem(type, item, quantity = 1) {
      if (!item || quantity == 0)
        return;

      const existItem = items.find((existItem) => existItem.id === item.id);

      if (existItem) {
        if (type === 'fasteners_separate') {
          existItem.quantity = quantity;
          return
        }
        existItem.quantity += quantity;
      } else {
        items.push({
          type,
          id: item.id,
          name: item.name,
          price: item.price,
          quantity,
        });
      }
    }

    const walls = ({
      1600: {500: 3, 2000: 0},
      1850: {500: 3, 2000: 0},
      2000: {500: 0, 2000: 1},
      2200: {500: 0, 2000: 1},
      2350: {500: 0, 2000: 1},
      2550: {500: 1, 2000: 1},
      2750: {500: 1, 2000: 1},
      3100: {500: 2, 2000: 1},
    })[row.height];

    const rack_count = (row.separate ? row.sections.length * 4 : row.sections.length * 2 + 2);
    const rack_kit_type = (row.capacity.rack_kit_hard ? 'hard' : 'strong');
    const rack_kit = data.rack_kit.find(rack_kit => {
      return (rack_kit.height == row.height && rack_kit.type == rack_kit_type);
    });
    addItem('rack_kit', rack_kit, rack_count);

    const tier_shelf_type = (row.capacity.tier_shelf_hard ? 'hard' : 'strong');

    const fasteners = {
      t_amplifier: data.t_amplifier.find(fastener => fastener.type == rack_kit_type),
      rack_fasteners: data.rack_fasteners.find(fastener => fastener.type == rack_kit_type),
      g_amplifier: data.g_amplifier[0],
    };

    row.sections.forEach(section => {
      const tier_shelf = data.tier_shelf.find(tier_shelf => {
        return (tier_shelf.depth == row.depth && tier_shelf.length == section.width && tier_shelf.type == tier_shelf_type);
      });
      addItem('tier_shelf', tier_shelf, section.count);

      if (row.capacity.tier_shelf_ribs) {
        const tier_shelf_rib = data.tier_shelf_ribs.find(tier_shelf_rib => tier_shelf_rib.length == section.width);
        addItem('tier_shelf_rib', tier_shelf_rib, section.count * 2);
      }

      if (row.capacity.fasteners === 'g2') {
        if (!row.separate) {
          const fasteners_count = row.sections.length * 2 + 2;
          addItem('fasteners_separate', fasteners.rack_fasteners, fasteners_count);
          return
        }
        addItem('fasteners', fasteners.rack_fasteners, 4);
      } else if (row.capacity.fasteners === 'g3') {
        addItem('fasteners', fasteners.rack_fasteners, 4);
        addItem('fasteners', fasteners.g_amplifier, 1);
      } else if (row.capacity.fasteners === 'gall') {
        addItem('fasteners', fasteners.rack_fasteners, 4);
        addItem('fasteners', fasteners.g_amplifier, section.count - 2);
      } else if (row.capacity.fasteners === 't2') {
        addItem('fasteners', fasteners.t_amplifier, 4);
      } else if (row.capacity.fasteners === 't3') {
        addItem('fasteners', fasteners.t_amplifier, 6);
      } else if (row.capacity.fasteners === 'tall') {
        addItem('fasteners', fasteners.t_amplifier, section.count * 2);
      }

      if (row.height >= 2200 && row.capacity.fasteners !== 't3' && row.capacity.fasteners !== 'tall') {
        addItem('fasteners', fasteners.g_amplifier, 1);
      }

      if (section.accessories.back_strips) {
        addItem('back_strips', data.back_strips.find(item => item.length == section.width), +section.accessories.back_strips_count);
      }

      if (section.accessories.side_strips_left) {
        addItem('side_strips', data.side_strips.find(item => item.depth == row.depth), +section.accessories.side_strips_left_count);
      }

      if (section.accessories.side_strips_right) {
        console.log(row.depth, +section.accessories.side_strips_right_count)
        addItem('side_strips', data.side_strips.find(item => item.depth == row.depth), +section.accessories.side_strips_right_count);
      }

      if (section.accessories.separators) {
        addItem('separators', data.separators.find(item => item.depth == row.depth), +section.accessories.separators_count);
      }

      if (section.accessories.back_screen) {
        addItem('back_screen', data.back_screen.find(item => item.length == section.width), +section.accessories.back_screen_count);
      }

      if (section.accessories.side_screen) {
        addItem('side_screen', data.side_screen.find(item => item.depth == row.depth), +section.accessories.side_screen_count);
      }

      for (const wall_height in walls) {
        const wall_quantity = walls[wall_height];

        if (section.accessories.back_wall) {
          addItem('back_wall', data.back_wall.find(item => item.length == section.width && item.height == wall_height), wall_quantity);
        }

        if (section.accessories.side_wall_right) {
          addItem('side_wall', data.side_wall.find(item => item.depth == row.depth && item.height == wall_height), wall_quantity);
        }

        if (section.accessories.side_wall_left) {
          addItem('side_wall', data.side_wall.find(item => item.depth == row.depth && item.height == wall_height), wall_quantity);
        }
      }
    });

    if (!row.separate) {
      if (row.side_wall === 'screen') {
        addItem('side_screen', data.side_screen.find(item => item.depth == row.depth), +row.side_wall_count);
      } else if (row.side_wall === 'wall') {
        for (const wall_height in walls) {
          const wall_quantity = walls[wall_height];

          if (row.side_wall_right) {
            addItem('side_wall', data.side_wall.find(item => item.depth == row.depth && item.height == wall_height), wall_quantity);
          }

          if (row.side_wall_left) {
            addItem('side_wall', data.side_wall.find(item => item.depth == row.depth && item.height == wall_height), wall_quantity);
          }
        }
      }
    }

    if (row.thrusters === 'metal') {
      addItem('thrusters', data.thrusters[0], rack_count);
    } else if (row.thrusters === 'adjustable') {
      addItem('thrusters', data.thrusters[0], rack_count);
      addItem('thrusters_screw', data.thrusters_screw[0], rack_count);
    }

    return {
      items,
      price: items.reduce((a, c) => a + c.price * c.quantity, 0).toFixed(2),
    };
  }
};
